export default {
  perfumes: {
    en: 'Perfumes',
  },
  allPerfumes: {
    en: 'All perfumes',
  },
  bestsellers: {
    en: 'Best sellers',
  },
  pom: {
    en: 'Perfume of the Month',
  },
  com: {
    en: 'Cologne of the Month',
  },
  clean: {
    en: 'Clean',
  },
  exclusive: {
    en: 'Exclusive',
  },
  collections: {
    en: 'Collections',
  },
  colognes: {
    en: 'Colognes',
  },
  allColognes: {
    en: 'All colognes',
  },
  newArrivals: {
    en: 'New arrivals',
  },
  referral: {
    en: 'Get a free scent',
  },
  newReferral: {
    // eslint-disable-next-line max-len
    en: 'You have <span class="{freeFragranceClassName}"><span class="bg-white rounded-full inline-block text-center font-bold inline-flex items-center justify-center availableCount {spanClassName}">{available}</span> free fragrances</span> to give away',
  },
  track: {
    en: 'Track your order',
  },
  queue: {
    en: 'Manage your fragrances',
  },
  makeup: {
    en: 'Makeup',
  },
  shop: {
    en: 'Shop',
  },
  shopAll: {
    en: 'Shop all',
  },
  discover: {
    en: 'Discover',
  },
  memberPerks: {
    en: 'Member perks',
  },
  gifts: {
    en: 'Gift Guide',
  },
  holidayGifts: {
    en: 'Holiday Gifts',
  },
  exclusives: {
    en: 'Gift guide exclusives',
  },
  allGifts: {
    en: 'All Gifts',
  },
  giftSubscription: {
    en: 'Gift Subscription',
  },
  coarPerfumeGiftSets: {
    en: 'COAR Perfume Gift Sets',
  },
  coarCologneGiftSets: {
    en: 'COAR Cologne Gift Sets',
  },
  sbGiftSets: {
    en: 'Scentbird gift sets',
  },
  giftSetsPage: {
    en: 'Gift Sets',
  },
  holidayBoxes: {
    en: 'Holiday boxes',
  },
  giftCard: {
    en: 'Gift Card',
  },
  giftBundles: {
    en: 'Gift bundles',
  },
  mySubscription: {
    en: 'My subscription',
  },
  beauty: {
    en: 'Beauty',
  },
  scentbird: {
    en: 'Scentbird',
  },
  edit: {
    en: 'The Edit',
  },
  fullSizeFragrances: {
    en: 'Full-size fragrances',
  },
  scentbirdCases: {
    en: 'Scentbird cases',
  },
  bathBody: {
    en: 'Bath & Body',
  },
  accessories: {
    en: 'Accessories',
  },
  samples: {
    en: '1.5 mL Samples',
  },
  candlesHomeScents: {
    en: 'Candles & Home scents',
  },
  scentProfile: {
    en: 'Scent profile',
  },
  fragranceFamilies: {
    en: 'Fragrance family library',
  },
  allBrands: {
    en: 'All brands',
  },
  careers: {
    en: 'Careers',
  },
  press: {
    en: 'For the press',
  },
  lastMinuteAddons: {
    en: 'Last minute add-ons',
  },
  caseSubscription: {
    en: 'Case subscription',
  },
  candleSubscription: {
    en: 'Candle Club',
  },
  buyYourQueue: {
    en: 'Buy your queue and save',
  },
  privateSale: {
    en: 'Private sale',
  },
  referralProgram: {
    en: 'Referral program',
  },
  aboutScentbird: {
    en: 'About  scentbird',
  },
  support: {
    en: 'Help & Support',
  },
  aboutUs: {
    en: 'About us',
  },
  featuredBrand: {
    en: 'Featured brand',
  },
  fomArchive: {
    en: 'Fragrance of the Month archive',
  },
  scentWorldPodcast: {
    en: 'Scent World podcast',
  },
  scentBlog: {
    en: 'Scent blog',
  },
  membership: {
    en: 'Your membership',
  },
  orderHistory: {
    en: 'Order tracking & history',
  },
  manageSubscription: {
    en: 'Manage subscription',
  },
  upgrade: {
    en: 'Upgrade your subscription',
  },
  subscribe: {
    en: 'Subscribe to Scentbird',
  },
  account: {
    en: 'Your account',
  },
  billingInfo: {
    en: 'Billing information',
  },
  shippingInfo: {
    en: 'Shipping information',
  },
  personalInfo: {
    en: 'Personal details & Password',
  },
  reviews: {
    en: 'Ratings & Reviews',
  },
  referFriend: {
    en: 'Refer a friend',
  },
  logoff: {
    en: 'Log out',
  },
  aria: {
    profileButton: {
      en: 'open profile menu',
    },
  },
  labels: {
    subscribed: {
      en: 'You\'re subscribed!',
    },
    newAtScentbird: {
      en: 'New at scentbird',
    },
    new: {
      en: 'New!',
    },
  },
  notesLibrary: {
    en: 'Notes library',
  },
  saksCollaboration: {
    en: 'Saks x Scentbird',
  },
  scentHoroscope: {
    en: 'Scent Horoscope',
  },
}
